module.exports = __webpack_public_path__ + "img/Frame 5133.0817ad38.jpg";